import { getInitialVisibility } from '../../../../hooks/useVisibilityResolve';

export type FormVisibilityNode = {
  name?: string;
  label?: string;
  visible?: boolean | string;
  allowVisible?: boolean;
  items?: FormVisibilityNode[];
};

export const getInitialFormItemVisibility = (
  node: FormVisibilityNode
): boolean => {
  if (node.allowVisible === false) {
    return false;
  }

  if (!getInitialVisibility(node.visible)) {
    return false;
  }

  if (!Array.isArray(node.items)) {
    return true;
  }

  return node.items.some(getInitialFormItemVisibility);
};
